<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>
        <app-meeting-combobox :filter="payload" @onChange="setReportName">
        </app-meeting-combobox>
      </v-col>
      <v-col sm="2" offset-sm="1" class="text-right">
        <v-btn outlined color="primary" class="ml-3" @click="validar()">
          <span>Finalizar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.encontro.inicioString"
          v-mask="'##/##/####'"
          :label="`Data ${isAT ? 'da Agenda' : 'do Encontro'}`"
          readonly
        ></v-text-field>
      </v-col>
      <v-col>
        <combobox-encontro-tipo
          :filter="payload"
          :readonly="verTipoEncontro"
        ></combobox-encontro-tipo>
      </v-col>
      <v-col
        style="display: flex; align-items: center"
        v-if="
          isFullAdmin ||
          (config.verParcialAcaoFinalizada &&
            groupsConfig.verParcialAcaoFinalizada)
        "
      >
        <strong>Tipo {{ isAT ? "da Agenda" : "do Encontro" }}:</strong>
        <span class="ml-2">{{ payload.encontro.encontroType }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.inicioString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Início"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="payload.fimString"
          v-mask="'##/##/#### ##:##'"
          label="Data de Término"
          placeholder="00/00/0000 00:00"
          disabled
        ></v-text-field>
      </v-col>

      <v-col v-if="encontroTipoEnum.hibrido !== payload.encontrosTipoId">
        <v-text-field
          :required="true"
          v-restrict.number
          v-model="payload.horasUtilizadasString"
          label="Horas Utilizadas"
          placeholder="0"
          persistent-hint
          :disabled="
            !isFullAdmin &&
            ((!config.editaHorasUtilizadas &&
              !groupsConfig.editaHorasUtilizadas) ||
              bloquearhorasUtilizadas)
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="encontroTipoEnum.hibrido === payload.encontrosTipoId">
      <v-col>
        <v-text-field
          v-restrict.number
          v-model="payload.horasUtilizadasString"
          label="Horas Utilizadas"
          placeholder="0"
          persistent-hint
          :disabled="
            !isFullAdmin &&
            ((!config.editaHorasUtilizadas &&
              !groupsConfig.editaHorasUtilizadas) ||
              bloquearhorasUtilizadas)
          "
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-restrict.number
          v-model="payload.horasRemotasString"
          label="Horas Remotas"
          placeholder="0"
          persistent-hint
          :disabled="
            !isFullAdmin &&
            !config.relatorioHorasRemotasHorasPresenciais &&
            !groupsConfig.relatorioHorasRemotasHorasPresenciais
          "
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-restrict.number
          v-model="payload.horasPresenciaisString"
          label="Horas Presenciais"
          placeholder="0"
          persistent-hint
          :disabled="
            !isFullAdmin &&
            !config.relatorioHorasRemotasHorasPresenciais &&
            !groupsConfig.relatorioHorasRemotasHorasPresenciais
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      v-if="
        isFullAdmin ||
        (config.exibirPjAtendida && groupsConfig.exibirPjAtendida) ||
        (config.exibirPfAtendida && groupsConfig.exibirPfAtendida)
      "
    >
      <v-col>
        <v-text-field
          v-if="
            isFullAdmin ||
            (config.exibirPfAtendida && groupsConfig.exibirPfAtendida)
          "
          v-restrict.number
          v-model="payload.pjAtendidas"
          label="Pessoas Físicas Atendidas"
          placeholder="0"
          persistent-hint
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-if="
            isFullAdmin ||
            (config.exibirPjAtendida && groupsConfig.exibirPjAtendida)
          "
          v-restrict.number
          v-model="payload.pfAtendidas"
          label="Empresas Atendidas"
          placeholder="0"
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-multiple-plus</v-icon>
          Convidados
        </v-tab>
        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>
        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          {{ isAT ? "Iniciativas" : "Tarefas" }}
        </v-tab>
        <v-tab>
          <v-icon left>mdi-android-messages</v-icon>
          Observações
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              label="Relatório do evento"
              required
              v-model="payload.descricao"
              :spellcheck="true"
              autocomplete="on"
              lang="pt-BR"
              class="spell-check-enabled"
            ></v-textarea>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <app-modal-insert-member
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :municipioId="payload.municipioId"
              :grupo="payload.encontro.grupo"
              @onSave="getMembers"
            >
              <template v-slot:title :edit="false"> Cadastrar Membro </template>
            </app-modal-insert-member>
          </v-col>

          <v-col>
            <v-combobox
              v-model="payload.convidadosRelatorio"
              :items="membros"
              chips
              clearable
              label="Membros"
              item-text="nome"
              item-value="membroId"
              multiple
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip close @click:close="removeMembro(item)">
                  <strong>{{ item.nome }} - {{ item.cpf }}</strong>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
          <v-data-table
            :headers="headersConvidados"
            :items="payload.convidadosRelatorio"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.presente="{ item }">
              <v-checkbox
                v-model="item.presente"
                :id="'membro' + item.membroId"
                color="primary"
              >
              </v-checkbox>
            </template>

            <template slot="no-data">
              <span> Nenhum convidado adicionado </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <template>
              <v-file-input
                multiple
                label="Anexar arquivos"
                v-model="payload.currArquivos"
                @change="inputChanged"
                hint="Adicione 1 ou mais arquivos relacionados ao relatório"
                persistent-hint
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0">
                    {{ payload.currArquivos.length }}
                    {{
                      payload.currArquivos.length === 1 ? "arquivo" : "arquivos"
                    }}
                  </span>
                </template>
              </v-file-input>

              <v-data-table
                :headers="headersAnexos"
                :items="payload.arquivos"
                class="elevation-1 mt-4"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.nome="{ item }">
                  <span>{{ item.name }}</span>
                </template>

                <template v-slot:item.remover="{ item }">
                  <v-btn outlined color="error" small @click="removeFile(item)">
                    Remover
                  </v-btn>
                </template>

                <template slot="no-data">
                  <span> Nenhum anexo adicionado </span>
                </template>
              </v-data-table>
            </template>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="headers"
            :items="payload.tarefasRelatorio"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.cumprida="{ item }">
              <v-checkbox
                v-model="item.cumprida"
                :id="'cumprida' + item.tarefaId"
                color="primary"
                :disabled="true"
              >
              </v-checkbox>
            </template>

            <template
              v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{ item }"
            >
              <span
                v-for="evidencia in item.municipioTarefa.municipioEvidencias"
                :key="evidencia.municipioEvidenciaId"
              >
                {{ evidencia.nome }} |
              </span>
            </template>

            <template slot="no-data">
              <span> Nenhuma tarefa retornada </span>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <v-textarea v-model="payload.observacoes"></v-textarea>
          </v-col>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { memberAPI } from "@/modules/city/components/MemberAPI";
import { reportAPI } from "@/modules/report";
import { mapActions, mapGetters } from "vuex";
import { AppMeetingCombobox } from "@/modules/calendar";
import AppModalInsertTask from "./ModalInsertTask";
import { AppCityHeader } from "@/modules/city";
import AppModalInsertMember from "@/modules/city/components/group/ModalInsertMember";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI.js";
import ComboboxEncontroTipo from "@/components/calendar/encontroTipo/ComboboxEncontroTipo.vue";
import { encontroTipoEnum } from "@/components/calendar/encontroTipo/encontroTipoEnum.js";
import Swal from "sweetalert2";

export default {
  components: {
    AppMeetingCombobox,
    AppModalInsertTask,
    AppCityHeader,
    AppModalInsertMember,
    ComboboxEncontroTipo,
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      tiposExecucao: [
        { text: "Presencial", value: 1 },
        { text: "Remoto", value: 2 },
      ],
      encontroTipoEnum: encontroTipoEnum,

      payload: {
        arquivos: [],
        currArquivos: [],
        convidadosRelatorio: [],
        descricao: null,
        encontroId: 0,
        municipioId: this.$route.params.id,
        titulo: null,
        tarefasRelatorio: [],
        observacoes: null,
        encontro: {
          inicioString: null,
        },
        encontrosTipoId: 1,
      },
      membros: [],
      headers: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Horas", value: "municipioTarefa.horas" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "remover", align: "end" },
      ],
      estado: this.$store.state.uf,
      bloquearhorasUtilizadas: false,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    // Função para sanitizar o texto antes do envio
    sanitizeText(text) {
      if (!text) return "";
      // Remove scripts e tags HTML maliciosas
      return String(text)
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
        .replace(/on\w+="[^"]*"/g, "");
    },

    testaHoras() {
      let contratoId;
      const findContrato =
        this.payload?.encontro?.solucoesEvento[0]?.contratoRelacao?.usuarioId ==
        this.user?.usuarioId;

      if (!this.payload?.encontro?.solucoesEvento[0]?.contratoRelacao) {
        this.testarConfirmacao();
      } else {
        let contratoWithMunicipioSolucaoContrato =
          this.payload?.encontro?.solucoesEvento[0]?.municipioSolucaoContrato
            ?.filter(
              (item) => item?.contrato?.usuarioId == this.user?.usuarioId
            )
            .map((item) => item?.contratoId);

        let contratoWithMunicipioSolucao = null;

        if (findContrato) {
          contratoWithMunicipioSolucao =
            this.payload?.encontro?.solucoesEvento[0]?.contratoRelacao
              ?.contratoId;
        }

        contratoId =
          contratoWithMunicipioSolucaoContrato?.length == 0
            ? contratoWithMunicipioSolucao
            : contratoWithMunicipioSolucaoContrato[0];

        if (contratoId) {
          this.setLoading(true);

          cityTaskAPI.testaHoras(contratoId).then((resp) => {
            this.setLoading(false);

            const { data: horas } = resp;
            this.testarConfirmacao(horas);
          });
        } else {
          this.testarConfirmacao();
        }
      }
    },

    testarConfirmacao(horas) {
      let erro = false;
      if (horas) {
        // let verificarDataHorasAgendadas =
        //   this.verificarDataHorasAgendadas(horas);
        let verificarDataHoraAprovadas =
          this.verificarDataHorasAprovadas(horas);

        if (!verificarDataHoraAprovadas) {
          this.$notification.error(
            "As horas utilizadas ultrapassam o limite de horas do contrato"
          );
          erro = true;
        }

        if (!erro) {
          this.save();
        }
      } else {
        this.save();
      }
    },
    verificarDataHorasAgendadas(resp) {
      const soma =
        parseInt(resp.horasAgendadas) +
        parseInt(this.payload?.horasUtilizadasString || 0);

      return resp.qtdHorasPrevistas >= soma;
    },
    verificarDataHorasAprovadas(resp) {
      const soma =
        parseInt(resp.horasAprovadas) +
        parseInt(this.payload?.horasUtilizadasString || 0);

      return resp.qtdHorasPrevistas >= soma;
    },
    async validar() {
      if (!this.payload.descricao) {
        this.$notification.error(
          `É necessário preencher o relatório do evento`
        );
        return;
      }
      if (!this.payload.encontroId || this.payload.encontroId === 0) {
        this.$notification.error(
          `${this.isAT ? "A agenda" : "O encontro"} deve estar preenchido`
        );
        return;
      }

      const podeProsseguirIa = await this.validarRascunhoIa();
      if (!podeProsseguirIa) {
        return;
      }

      if (
        this.relatorioHorasRemotasHorasPresenciais &&
        this.payload.encontrosTipoId === this.encontroTipoEnum.hibrido
      ) {
        const conta =
          (parseInt(this.payload.horasRemotasString) || 0) +
          (parseInt(this.payload.horasPresenciaisString) || 0);
        const totalHoras = parseInt(this.payload.horasUtilizadasString) || 0;
        if (conta != totalHoras) {
          this.$notification.error(
            "A soma das horas remotas e presenciais deve ser igual ao total de horas utilizadas"
          );
          return;
        }
      }

      if (
        (this.estado === "SC" ||
          this.estado === "MS" ||
          this.estado === "BA" ||
          this.estado === "SP" ||
          this.estado === "MA" ||
          this.estado === "RJ") &&
        !this.payload.horasUtilizadasString
      ) {
        this.payload.horasUtilizadasString = "0";
      } else {
        if (
          this.config.umTarefaValorRelatorio &&
          this.groupsConfig.umTarefaValorRelatorio
        ) {
          if (
            this.payload &&
            this.payload.tarefasRelatorio &&
            this.payload.tarefasRelatorio.length == 1
          ) {
            this.payload.tarefasRelatorio = this.payload.tarefasRelatorio.map(
              (item) => ({
                ...item,
                municipioTarefa: {
                  ...item.municipioTarefa,
                  horas: this.payload.horasUtilizadasString,
                },
              })
            );
          }
        }

        this.testaHoras();
      }
    },
    analiseRelatorioIaAtiva() {
      const config = this.config || {};
      const groupsConfig = this.groupsConfig || {};
      const configAtivo =
        config.analiseRelatorioIA ||
        config.AnaliseRelatorioIA ||
        config.analiseRelatoriosIa ||
        config.AnaliseRelatoriosIa;
      const grupoAtivo =
        groupsConfig.analiseRelatorioIA ||
        groupsConfig.AnaliseRelatorioIA ||
        groupsConfig.analiseRelatoriosIa ||
        groupsConfig.AnaliseRelatoriosIa;
      return configAtivo && grupoAtivo;
    },
    escaparHtml(valor) {
      const mapa = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      };
      return String(valor == null ? "" : valor).replace(
        /[&<>"']/g,
        (caractere) => mapa[caractere]
      );
    },
    listaAnaliseIaHtml(itens) {
      return (Array.isArray(itens) ? itens : [])
        .filter((item) => item != null && String(item).trim())
        .map((item) => `<li>${this.escaparHtml(item)}</li>`)
        .join("");
    },
    async validarRascunhoIa() {
      if (!this.analiseRelatorioIaAtiva()) {
        return true;
      }

      this.setLoading(true);
      try {
        const { data } = await reportAPI.analisarRascunhoIa(
          {
            encontroId: this.payload.encontroId,
            municipioId: Number(this.payload.municipioId),
            titulo: this.payload.titulo,
            descricao: this.payload.descricao,
            observacoes: this.payload.observacoes,
            complemento: this.payload.complemento,
            horasUtilizadasString: this.payload.horasUtilizadasString,
          },
          this.payload.arquivos || []
        );

        this.setLoading(false);
        if (
          !data ||
          data.analiseGenerativaExecutada !== true ||
          data.statusIa !== "CONCLUIDA_OPENAI" ||
          !data.analiseId
        ) {
          throw new Error("O agente de IA nao confirmou a analise.");
        }

        const pontosCoerentes = this.listaAnaliseIaHtml(data.pontosCoerentes);
        const inconsistencias = this.listaAnaliseIaHtml(
          data.inconsistencias
        );
        const sugestoes = this.listaAnaliseIaHtml(data.sugestoes);
        const resumo = this.escaparHtml(data.resumoContextualIa);
        const aderencia = this.escaparHtml(data.aderenciaContextoIa);
        const aderenciaAnexos = this.escaparHtml(data.aderenciaAnexosIa);
        const justificativa = this.escaparHtml(data.justificativaIa);
        const analisesAnexos = (Array.isArray(data.analisesAnexos)
          ? data.analisesAnexos
          : []
        )
          .map(
            (anexo) => `
              <li style="margin-bottom:8px">
                <strong>${this.escaparHtml(anexo.nome)}</strong> —
                ${this.escaparHtml(anexo.aderenciaEntrega)}
                (${this.escaparHtml(anexo.statusLeitura)})
                <br>${this.escaparHtml(anexo.resumoConteudo)}
                ${
                  anexo.justificativa
                    ? `<br><em>${this.escaparHtml(anexo.justificativa)}</em>`
                    : ""
                }
              </li>
            `
          )
          .join("");

        if (!data.recomendaRevisaoHumana) {
          await Swal.fire({
            icon: "success",
            title: "Analise contextual da IA concluida",
            html: `
              <div style="text-align:left">
                <p><strong>Leitura do relatorio</strong></p>
                <p>${resumo}</p>
                <p><strong>Aderencia ao produto, solucao e tarefas</strong></p>
                <p>${aderencia}</p>
                <p><strong>Aderencia dos anexos a entrega e a execucao</strong></p>
                <p>${aderenciaAnexos}</p>
                ${
                  analisesAnexos
                    ? `<ul>${analisesAnexos}</ul>`
                    : ""
                }
                ${
                  pontosCoerentes
                    ? `<p><strong>Pontos coerentes identificados</strong></p><ul>${pontosCoerentes}</ul>`
                    : ""
                }
                ${justificativa ? `<p>${justificativa}</p>` : ""}
              </div>
            `,
            confirmButtonText: "Continuar",
            width: 760,
          });
          return true;
        }

        const result = await Swal.fire({
          icon: "warning",
          title: "Atencao: seu relatorio possui pontos para revisao",
          html: `
            <div style="text-align:left">
              <p><strong>Decisao IA:</strong> ${this.escaparHtml(
                data.decisaoIa
              )} | <strong>Risco:</strong> ${this.escaparHtml(
            data.nivelRiscoIa
          )}</p>
              <p><strong>Leitura do relatorio</strong></p>
              <p>${resumo}</p>
              <p><strong>Aderencia ao produto, solucao e tarefas</strong></p>
              <p>${aderencia}</p>
              <p><strong>Aderencia dos anexos a entrega e a execucao</strong></p>
              <p>${aderenciaAnexos}</p>
              ${
                analisesAnexos
                  ? `<ul>${analisesAnexos}</ul>`
                  : ""
              }
              ${
                pontosCoerentes
                  ? `<p><strong>Pontos coerentes identificados</strong></p><ul>${pontosCoerentes}</ul>`
                  : ""
              }
              ${justificativa ? `<p>${justificativa}</p>` : ""}
              ${
                inconsistencias
                  ? `<p><strong>Inconsistencias especificas</strong></p><ul>${inconsistencias}</ul>`
                  : ""
              }
              ${
                sugestoes
                  ? `<p><strong>Sugestoes ligadas ao contexto</strong></p><ul>${sugestoes}</ul>`
                  : ""
              }
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: "Finalizar mesmo assim",
          cancelButtonText: "Revisar agora",
          reverseButtons: true,
          width: 720,
        });

        return result.isConfirmed;
      } catch (error) {
        this.setLoading(false);
        const result = await Swal.fire({
          icon: "warning",
          title: "O agente de IA nao respondeu",
          text: "Nenhuma recomendacao automatica foi aplicada. Voce pode revisar o relatorio agora ou finalizar mesmo assim.",
          showCancelButton: true,
          confirmButtonText: "Finalizar mesmo assim",
          cancelButtonText: "Revisar agora",
          reverseButtons: true,
        });
        return result.isConfirmed;
      }
    },
    save() {
      this.setLoading(true);
      let formData = new FormData();

      for (let i = 0; i < this.payload.arquivos.length; i++) {
        formData.append("arquivos", this.payload.arquivos[i]);
      }

      formData.append(
        "convidadosRelatorioString",
        JSON.stringify(this.payload.convidadosRelatorio)
      );
      formData.append(
        "tarefasRelatorioString",
        JSON.stringify(this.payload.tarefasRelatorio)
      );
      // Sanitiza o texto antes de enviá-lo
      formData.append("descricao", this.sanitizeText(this.payload.descricao));
      formData.append("encontroId", this.payload.encontroId);
      formData.append("municipioId", this.payload.municipioId);
      formData.append("horasRemotasString", this.payload.horasRemotasString);
      formData.append(
        "horasPresenciaisString",
        this.payload.horasPresenciaisString
      );
      formData.append("titulo", this.payload.titulo);
      if (this.payload.pjAtendidas) {
        formData.append("pjAtendidas", this.payload.pjAtendidas);
      }
      if (this.payload.pfAtendidas) {
        formData.append("pfAtendidas", this.payload.pfAtendidas);
      }
      if (this.payload.encontrosTipoId) {
        formData.append(
          "tipoExecucaoRelatorioId",
          this.payload.encontrosTipoId
        );
      }
      if (this.payload.horasUtilizadasString) {
        formData.append(
          "horasUtilizadasString",
          this.payload.horasUtilizadasString
        );
      }
      formData.append("inicioString", this.payload.inicioString);
      formData.append("fimString", this.payload.fimString);
      if (this.payload.observacoes) {
        formData.append("observacoes", this.payload.observacoes);
      }
      if (this.payload.motivoRejeicao) {
        formData.append("motivoRejeicao", this.payload.motivoRejeicao);
      }
      if (this.payload.complemento) {
        formData.append("complemento", this.payload.complemento);
      }
      reportAPI
        .create(formData)
        .then((resp) => {
          this.$notification.success("Relatório salvo com sucesso");
          this.$router.push(
            "/cidade/" + this.payload.municipioId + "/relatorio"
          );
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar relatório");
        });
    },
    setReportName(meetings, encontroId) {
      this.setLoading(true);
      this.payload.encontro = meetings.find(
        (item) => item.encontroId === encontroId
      );

      this.payload.titulo = this.payload.encontro.grupoData;
      this.payload.encontroId = this.payload.encontro.encontroId;
      this.payload.convidadosRelatorio = this.payload.encontro.convidadosEvento;
      this.payload.tarefasRelatorio = [];
      this.payload.inicioString = this.payload.encontro.inicioString;
      this.payload.fimString = this.payload.encontro.fimString;
      if (this.verTipoEncontro) {
        this.payload.encontrosTipoId = this.payload.encontro.encontrosTipoId;
      }
      this.payload.horasUtilizadasString = this.payload.encontro.tarefas.reduce(
        function (a, b) {
          return a + b.municipioTarefa.horas;
        },
        0
      );

      for (
        let count = 0;
        count < this.payload.encontro.tarefas.length;
        count++
      ) {
        this.payload.tarefasRelatorio.push({
          municipioTarefa: this.payload.encontro.tarefas[count].municipioTarefa,
          municipioTarefaId:
            this.payload.encontro.tarefas[count].municipioTarefaId,
          cumprida: true,
        });
      }

      for (
        let count = 0;
        count < this.payload.convidadosRelatorio.length;
        count++
      ) {
        this.payload.convidadosRelatorio[count].presente = true;
      }

      if (
        this.payload.tarefasRelatorio &&
        this.payload.tarefasRelatorio.length > 0
      ) {
        if (this.editaHorasUtilizadasQuandoTarefasSemHrPredefinidas) {
          // Verifica se todos têm tarefaId null
          const todosTarefaIdNull = this.payload.tarefasRelatorio.every(
            (item) =>
              !item.municipioTarefa.tarefaId ||
              item.municipioTarefa.tarefaId === null
          );

          if (todosTarefaIdNull) {
            this.bloquearhorasUtilizadas = false;
          } else {
            this.bloquearhorasUtilizadas = true;
          }
        }
        const todosTarefaSemHoras = this.payload.tarefasRelatorio.every(
          (item) =>
            !item.municipioTarefa.horas ||
            item.municipioTarefa.horas === null ||
            item.municipioTarefa.horas === 0
        );
        //Vamos lá: mantém tudo que existe e acrescenta se for MS e existir tarefas e as horas totais forem zero libera pra editar - Aluiz dia 23/07/2026
        if (this.uf === "MS" && todosTarefaSemHoras) {
          this.bloquearhorasUtilizadas = false;
        }
      } else {
        this.bloquearhorasUtilizadas = false;
      }

      this.getMembers();
    },
    getMembers() {
      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.payload.municipioId)
        .then((resp) => {
          this.membros = resp.data;
          this.onMemberClick();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    addTask(tasks) {
      for (let count = 0; count < tasks.length; count++) {
        this.payload.tarefasRelatorio.push({
          municipioTarefa: tasks[count],
          municipioTarefaId: tasks[count].municipioTarefaId,
          cumprida: true,
        });
      }
    },
    onMemberClick() {
      for (let count = 0; count < this.membros.length; count++) {
        this.membros[count].presente = true;
      }
    },
    getFileKey(file) {
      return `${file.name}-${file.size}-${file.lastModified}`;
    },
    inputChanged(files) {
      const selectedFiles = Array.isArray(files) ? files : files ? [files] : [];

      if (!selectedFiles.length) {
        this.payload.currArquivos = [];
        return;
      }

      const existingKeys = new Set(
        (this.payload.arquivos || []).map((item) => this.getFileKey(item))
      );

      const newFiles = selectedFiles.filter((file) => {
        const fileKey = this.getFileKey(file);
        if (existingKeys.has(fileKey)) {
          return false;
        }

        existingKeys.add(fileKey);
        return true;
      });

      this.payload.arquivos = [...(this.payload.arquivos || []), ...newFiles];

      // Limpa o input para permitir selecionar arquivos de outras pastas.
      this.$nextTick(() => {
        this.payload.currArquivos = [];
      });
    },
    removeAllFiles() {
      this.payload.arquivos = [];
      this.payload.currArquivos = [];
    },
    removeFile(file) {
      this.payload.arquivos = this.payload.arquivos.filter(
        (item) => item !== file
      );
      this.payload.currArquivos = [];
    },
  },

  computed: {
    ...mapGetters(["loading", "isFullAdmin", "isAT", "user", "uf"]),
    editaHorasUtilizadasQuandoTarefasSemHrPredefinidas() {
      return (
        this.isFullAdmin ||
        (this.config.editaHorasUtilizadasQuandoTarefasSemHrPredefinidas &&
          this.groupsConfig.editaHorasUtilizadasQuandoTarefasSemHrPredefinidas)
      );
    },
    relatorioHorasRemotasHorasPresenciais() {
      return (
        this.isFullAdmin ||
        (this.config.relatorioHorasRemotasHorasPresenciais &&
          this.groupsConfig.relatorioHorasRemotasHorasPresenciais)
      );
    },
    verTipoEncontro() {
      return (
        // this.isFullAdmin ||
        this.config.verTipoEncontro && this.groupsConfig.verTipoEncontro
      );
    },
  },
};
</script>

<style>
/* Garante que a verificação ortográfica funcione corretamente */
.spell-check-enabled {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Reforça sublinhado vermelho em palavras com erro ortográfico */
.spell-check-enabled textarea::spelling-error {
  text-decoration: wavy underline red;
}
</style>
